export const toggleBottomBar = (shouldShow) => (dispatch) => {
    dispatch(request());

    try {
        dispatch(success(shouldShow));
    } catch (error) {
        dispatch(failure("Unable to toggle bottom bar"));
    }

    function request() {
        return { type: "TOGGLE_BOTTOM_BAR_REQUEST" };
    }

    function success(payload) {
        return { type: "TOGGLE_BOTTOM_BAR_SUCCESS", payload };
    }

    function failure(error) {
        return { type: "TOGGLE_BOTTOM_BAR_FAILURE", payload: error };
    }
};
